module.exports = __webpack_public_path__ + "static/media/mx.pictogram.4b33e6ad.svg";